import { render, staticRenderFns } from "./SingleOfferView.vue?vue&type=template&id=905cde7a&scoped=true&xmlns%3Av-touch=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./SingleOfferView.vue?vue&type=script&lang=js"
export * from "./SingleOfferView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905cde7a",
  null
  
)

export default component.exports